import { gql } from "@apollo/client";

export const QUERY_COMPLETED_TASK = gql`
  query dailyTaskHasBeenCompleted(
    $day: Date!
    $type: String!
    $relationID: Int!
    $staffId: ID!
  ) {
    completedTasks: completedTasks_connection(
      filters: {
        day: { eq: $day }
        type: { eq: $type }
        done: { eq: true }
        relationID: { eq: $relationID }
        staff: { documentId: { eq: $staffId } }
      }
    ) {
      data {
        attributes {
          metadata
        }
      }
    }
  }
`;

export const QUERY_TRACKING_LEADERSHIP_WHEEL = gql`
  query dailyTrackingLeadershipWheel($startDay: Date!, $endDay: Date!) {
    leadershipWheelTracker(startDay: $startDay, endDay: $endDay) {
      focusArea
      day
      isDisabledTracking
    }
  }
`;

export const QUERY_USER_TRACKING_DATA = gql`
  query getUserTrackingData {
    getUserTrackingData {
      dailyStreak
      streakRecord
      emotionsTracked
    }
  }
`;

export const QUERY_FETCH_USER_STREAK = gql`
  query fetchUserStreak($type: String!) {
    fetchUserStreak(type: $type) {
      total
      streak
    }
  }
`;
